module.exports = __webpack_public_path__ + "img/proj6-rubyagro.1d1ba033.png";